import React from 'react';

import { dateFormat } from '@common/typescript/Utils';

import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import { TestimonialCard } from '@app/objects/TestimonialCard';
import '@app/scss/components/cardTestimonial.scss';

const CardTestimonial: React.FC<TestimonialCard> = (props) => {
	const {
		id,
		vetName,
		vetAvatar,
		authorFirstName,
		authorLastName,
		location,
		text,
		date,
		avatarHeight = 100,
		avatarWidth = 100,
		extraText = '',
	} = props;

	return (
		<article className="testimonial">
			{vetName && (
				<header className="testimonial__vet">
					{vetAvatar && (
						<div className="testimonial__vet-img">
							<CustomAvatar
								src={vetAvatar}
								maxWidth={avatarWidth}
								maxHeight={avatarHeight}
							/>
						</div>
					)}
					<span className="testimonial__vet-name">{vetName}</span>
				</header>
			)}
			<section className="testimonial__text">{text}</section>
			<footer className="testimonial__author">
				{(authorFirstName?.length || authorLastName?.length) && (
					<span className="testimonial__author-name">
						{authorFirstName?.length && authorFirstName}
						{' '}
						{authorLastName?.length && authorLastName}
					</span>
				)}
				<span className="testimonial__author-location">
					{extraText && `${extraText}, `}
					{location}
				</span>
				{date && (
					<span className="testimonial__author-date">
						{dateFormat(date, {
							day: 'numeric',
							month: 'long',
							year: 'numeric',
						})}
					</span>
				)}
			</footer>
		</article>
	);
};

export default CardTestimonial;
